import { useModuleLicense } from './useModuleLicense';

/**
 * The seats that reach the nursery's stock, orders and counter, from either
 * module that uses them (retail plan, 2026-10-12). Mirrors HHNodeServer
 * `middleware/stockAccess.js`, which is the real gate.
 *
 *   Retail staff   — the counter, lots, receiving, counting. A Nursery
 *                    manager on these pages.
 *   Retail manager — staff, plus the catalogue and the shop's prices. A
 *                    Nursery admin on these pages.
 */
export type StockLevel = 'count' | 'operate' | 'manage' | 'admin';

export const RETAIL_SEATS = ['staff', 'manager'];

export const STOCK_SEATS: Record<StockLevel, { nursery: string[]; retail: string[] }> = {
  count:   { nursery: ['picker', 'operator', 'manager', 'admin'], retail: RETAIL_SEATS },
  operate: { nursery: ['operator', 'manager', 'admin'], retail: RETAIL_SEATS },
  manage:  { nursery: ['manager', 'admin'], retail: RETAIL_SEATS },
  admin:   { nursery: ['admin'], retail: ['manager'] },
};

/** `alsoModules` for a LicenseGate on a page a Retail seat at this level opens. */
export function retailAlso(level: StockLevel) {
  return [{ moduleKey: 'retail', licenseType: STOCK_SEATS[level].retail }];
}

/** Whether the person holds a Nursery or Retail seat at this level. */
export function useStockSeat(level: StockLevel) {
  const nursery = useModuleLicense('nursery', STOCK_SEATS[level].nursery);
  const retail = useModuleLicense('retail', STOCK_SEATS[level].retail);
  return {
    hasAccess: nursery.hasAccess || retail.hasAccess,
    loading: nursery.loading || retail.loading,
    /** Reached through a Retail seat only: the shop's view of the page. */
    viaRetail: !nursery.hasAccess && retail.hasAccess,
  };
}
